export default "__VITE_ASSET__E0j8HDHE__"